<template>
  <!-- 产品中心 -->
  <div class="page">
    <div class="nav_top"></div>
    <navigation-bar2 />
    <!-- 轮播图 -->
    <SwiperPageProductCenter :lunboImg="lunboImgs" @update="getData" />
    <serch-product />
    <div class="searchBox">
      <div class="search">
        <el-input size="small" placeholder="" v-model="input" clearable></el-input>
        <el-button size="small" icon="el-icon-search" @click="queryInfoData"></el-button>
      </div>
    </div>
    <div class="list">
      <!-- left -->
      <div style="width: 20%;">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="vertical"
          @select="handleSelect"
          active-text-color="#1bbabe"
          style="text-align:left; padding-left: 30px; font-size: 18px; letter-spacing: 3px;"
        >
          <el-menu-item index="1">全部产品</el-menu-item>
          <el-menu-item index="2">环卫车辆</el-menu-item>
          <el-menu-item index="3">压缩设备</el-menu-item>
          <el-menu-item index="4">环保设备</el-menu-item>
          <el-menu-item index="5">环卫箱房</el-menu-item>
        </el-menu>
      </div>
      <!-- right -->
      <div class="right" style="width: 80%;">
        <div class="list_item" v-for="(item, index) in productInfo" :key="index">
          <div><img :src="imgUrl + item.img" alt="" /></div>
          <div class="viewDetails" @click="gotoDetails(item)">查看详情>></div>
        </div>
      </div>
    </div>
    <bottom-area />
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      lunboImgs: [],
      productInfo: [],
      input: "",
      type: 1,
      activeIndex: "1",
      imgUrl: this.$store.state.imgUrl,
    };
  },
  components: {
    NavigationBar2: () => import("../views/nav/NavigationBar2"),
    SwiperPageProductCenter: () => import("../views/swiper/SwiperPageProductCenter"),
    serchProduct: () => import("../views/searchProduct/serchProduct"),
    BrandProducts: () => import("../views/BrandProducts/BrandProducts"),
    ProductList: () => import("../views/ProductList/ProductList"),
    BottomArea: () => import("../views/footer/BottomArea"),
    Sidebar: () => import("../views/ProductList/Sidebar"),
  },
  created() {
    this.getData();
  },
  methods: {
    gotoDetails(item) {
      this.$store.dispatch("SET_IMG",item.detail_img);
    //  this.$store.commit("SET_IMGS",item.detail_img);
    //  localStorage.setItem('detail_img',item.detail_img);  //图片路径
    //  console.log(item.detail_img);
    //  console.log(this.$store.state.detail_img);
      this.$router.push({ path: "/details" });
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      this.type = key;
      this.getData();
    },
    async getData() {
      const { data: res } = await this.$http.get("/productInfo/list", {
        params: {
          type: this.type,
          value: this.input,
        },
      });
      if (res.code == 200) {
        this.lunboImgs = res.result.lunboImgs;
        this.productInfo = res.result.productInfo;
      }
    },
    queryInfoData() {
      this.getData();
    },
  },
  computed: {
    searchVal() {
      return this.$store.state.searchInput;
    },
    id() {
      return this.$store.state.productListMenuItem;
    },
  },
  watch: {
    searchVal(val) {
      console.log(val);
      this.getData();
    },
    id(val) {
      console.log(val);
      this.type = val;
      this.activeIndex = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
.nav_top {
  width: 100%;
  height: 15px;
  background-color: #19344a;
  color: #ffffff;
}
.searchBox {
  position: relative;
  width: 100%;
  .search {
    display: flex;
    position: absolute;
    top: -95px;
    right: 300px;
  }
}
.list {
  width: 100%;
  display: flex;
  padding: 50px 30px;
  overflow: hidden;
  box-sizing: border-box;
  .right {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .list_item {
      width: 430px;
      height: 400px;
      // background-color: pink;
      margin-bottom: 40px;
      img {
        width: 100%;
      }
      .viewDetails {
        height: 50px;
        line-height: 60px;
        text-align: center;
        cursor: pointer;
        font-size: 18px;
        color: #666666;
        letter-spacing: 5px;
      }
    }
    .list_item:hover {
      border-top: 0;
      box-shadow: 0px 0px 20px #cccccc;
      transition: 0.5s;
    }
  }
}
</style>
